import { render, staticRenderFns } from "./ModernView.vue?vue&type=template&id=66b4c3dc"
import script from "./ModernView.vue?vue&type=script&lang=js"
export * from "./ModernView.vue?vue&type=script&lang=js"
import style0 from "./ModernView.vue?vue&type=style&index=0&id=66b4c3dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports